import _ from "lodash";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

import SubjectsSetup from "Administrator/routes/AcademicSetup/routes/SubjectsSetup";
import UBDLearningStandards from "UBDAcademicSetup/routes/LearningStandards";
import EducatorCenterV2 from "Administrator/routes/AdminEducatorCenterV2";
import MYPLearningStandards from "Administrator/routes/MYPAcademicSetup/routes/LearningStandards";
import SubjectGroupsAndSubjects from "Administrator/routes/MYPAcademicSetup/routes/SubjectGroupsAndSubjects";
import NotificationsManager from "Administrator/routes/NotificationsManager";
import AdminScopeAndSequence from "Administrator/routes/AcademicSetup/routes/AdminScopeAndSequence";
import Trash from "Administrator/routes/Trash";
import SubjectStandardsV2 from "Administrator/commonComponents/SubjectStandardsV2";
import Datasets from "Datasets";
import Departments from "Platform/routes/AcademicPortal/routes/Departments";
import DPLearningStandards from "Administrator/routes/DPAcademicSetup/routes/DPLearningStandards";
import AdminGradeBook from "Administrator/routes/AdminGradebook";
import PlanningInsights from "PlanningInsights";
import YearGroup from "Administrator/routes/YearGroup";
import { ExamRegistration } from "Administrator/routes/DPExamRegistration";
import IBISRegistration from "Administrator/routes/IBISRegistration";
import { ECoursework } from "Administrator/routes/IB_ECoursework";
import RosterDataToNextAcademicYear from "Administrator/routes/RosterDataToNextAcademicYear";
import PortfolioSettingsTab from "../PortfolioSettingsTab";
import OtherModuleSettingsTab from "../OtherModuleSettingsTab";

//TODO: Move these routes to routes folder of CurriculumProgram
import SubjectsSetupV2 from "Platform/routes/AcademicPortal/routes/SubjectsSetupV2";
import {
  GradingSetupV2Route,
  SettingsRoute,
  LevelsRoute,
  DatasetsAndTemplatesRoute,
  ReportingSetupRoute,
  GradingSetupRoute,
  DPSubjectsRoute,
  AssessmentToolTemplatesRoute,
} from "AppComponents/AdminNavigation";

import {
  Timetable,
  AttendanceAndTimetableSettings,
} from "Administrator/routes";

export default store => ({
  path: ":curriculumProgramId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "curriculumProgram" */ "./components"),
        import(
          /* webpackChunkName: "curriculumProgram" */ "Administrator/routes/AcademicSetup/modules/AcademicSetupModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "academicSetup",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    SubjectsSetup(store),
    Timetable(store),
    AttendanceAndTimetableSettings(store),
    UBDLearningStandards(store),
    EducatorCenterV2(store),
    GradingSetupRoute(store),
    ReportingSetupRoute(store),
    DatasetsAndTemplatesRoute(store),
    ..._.map(ExamRegistration, route => route(store)),
    IBISRegistration(store),
    ..._.map(ECoursework, route => route(store)),
    DPSubjectsRoute(store),
    MYPLearningStandards(store),
    NotificationsManager(store),
    SubjectGroupsAndSubjects(store),
    AdminScopeAndSequence(store),
    SettingsRoute(store),
    PortfolioSettingsTab(store),
    OtherModuleSettingsTab(store),
    AssessmentToolTemplatesRoute(store),
    Trash(store),
    Departments(store),
    SubjectStandardsV2(store),
    Datasets(store),
    SubjectsSetupV2(store),
    GradingSetupV2Route(store),
    LevelsRoute(store),
    DPLearningStandards(store),
    AdminGradeBook(store),
    PlanningInsights(store),
    RosterDataToNextAcademicYear(store),
    YearGroup(store),
  ],
});
